import { isEmpty, isEqual, isNil, isString } from 'lodash';
import { FileUpload } from '@shared/types/fieldValues';
import { MAX_FILES_PER_FILE_INPUT } from '@shared/util/constants';
import { i18n } from '@shared/util/i18n';
import { EditableField, Field } from './Field';

export class FileField implements EditableField {
  readonly files: FileUpload[];
  readonly fieldType = 'FileField';

  constructor(files: FileUpload[]) {
    this.files = files;
  }

  validate(): string | null {
    if (this.files.length > MAX_FILES_PER_FILE_INPUT) {
      return i18n('workflowTemplate.component.error.file.maxExceeded', {
        count: MAX_FILES_PER_FILE_INPUT,
      });
    } else {
      return null;
    }
  }

  isEqual(field: Field): boolean {
    return field instanceof FileField && isEqual(this.files, field.files);
  }

  toFieldJson() {
    return this.files;
  }

  toDisplayString(): string {
    return this.files.map(file => file.name).join(', ');
  }

  get isEmpty() {
    return isEmpty(this.files);
  }

  static fromFieldJson(jsonBlob: any): FileField | null {
    if (Array.isArray(jsonBlob) && jsonBlob.every(isFileUpload)) {
      return new FileField(jsonBlob);
    } else {
      return null;
    }
  }
}

function isFileUpload(item: any): item is FileUpload {
  return !isNil(item) && isString(item.url) && isString(item.name) && isString(item.contentType);
}
